module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e6047"
    }
  }, [_c('span', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e53yui862412"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Text/Hunt_9781401684952_epub_c65_r1#d7e48",
      "id": "d6e48"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CKNOWLEDGMENTS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e40cfg058311"
    }
  }, [_c('span', [_c('a', {
    staticClass: "sgc-2",
    attrs: {
      "href": "#/Text/Hunt_9781401684952_epub_c52_r1#d7e35",
      "id": "d6e35"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e41fg574322"
    }
  }, [_c('span', [_c('span', {
    staticClass: "sgc-2",
    attrs: {
      "href": "#/Text/Hunt_9781401684952_epub_c53_r1#d7e36",
      "id": "d6e36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WO")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e422fgh98327"
    }
  }, [_c('span', [_c('span', {
    staticClass: "sgc-2",
    attrs: {
      "href": "#/Text/Hunt_9781401684952_epub_c54_r1#d7e37",
      "id": "d6e37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HREE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e43ghh369335"
    }
  }, [_c('span', [_c('span', {
    staticClass: "sgc-2",
    attrs: {
      "href": "#/Text/Hunt_9781401684952_epub_c55_r1#d7e38",
      "id": "d6e38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e43frh995340"
    }
  }, [_c('span', [_c('span', {
    staticClass: "sgc-2",
    attrs: {
      "href": "#/Text/Hunt_9781401684952_epub_c56_r1#d7e39",
      "id": "d6e39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e44dfgf602344"
    }
  }, [_c('span', [_c('span', {
    staticClass: "sgc-2",
    attrs: {
      "href": "#/Text/Hunt_9781401684952_epub_c57_r1#d7e40",
      "id": "d6e40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IX")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e456gh71352"
    }
  }, [_c('span', [_c('span', {
    staticClass: "sgc-2",
    attrs: {
      "href": "#/Text/Hunt_9781401684952_epub_c58_r1#d7e41",
      "id": "d6e41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVEN")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e466kkk35359"
    }
  }, [_c('span', [_c('span', {
    staticClass: "sgc-2",
    attrs: {
      "href": "#/Text/Hunt_9781401684952_epub_c59_r1#d7e42",
      "id": "d6e42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGHT")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e480hhh66369"
    }
  }, [_c('span', [_c('span', {
    staticClass: "sgc-2",
    attrs: {
      "href": "#/Text/Hunt_9781401684952_epub_c60_r1#d7e43",
      "id": "d6e43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e487yuy83375"
    }
  }, [_c('span', [_c('span', {
    staticClass: "sgc-2",
    attrs: {
      "href": "#/Text/Hunt_9781401684952_epub_c61_r1#d7e44",
      "id": "d6e44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EN")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e49ftft815382"
    }
  }, [_c('span', [_c('span', {
    staticClass: "sgc-2",
    attrs: {
      "href": "#/Text/Hunt_9781401684952_epub_c62_r1#d7e45",
      "id": "d6e45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEVEN")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e505ww75388"
    }
  }, [_c('span', [_c('span', {
    staticClass: "sgc-2",
    attrs: {
      "href": "#/Text/Hunt_9781401684952_epub_c63_r1#d7e46",
      "id": "d6e46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WELVE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e51tyy924398"
    }
  }, [_c('span', [_c('span', {
    staticClass: "sgc-2",
    attrs: {
      "href": "#/Text/Hunt_9781401684952_epub_c64_r1#d7e47",
      "id": "d6e47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIRTEEN")])])])]), _vm._v(" "), _c('p', [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e54tgyy298416"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Hunt_9781401684952_epub_c67_r1#d7e50",
      "id": "d6e50",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MITTEN")])]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("WITH")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIENDSHIP")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e557io47431"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Hunt_9781401684952_epub_c66_r1",
      "id": "d6e51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XCERPT")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROM")]), _vm._v(" A C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OWBOY'S")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUCH")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e55ui955432"
    }
  }, [_c('span', [_c('span', {
    staticClass: "sgc-2",
    attrs: {
      "href": "#/Text/Hunt_9781401684952_epub_c75_r1#d7e54",
      "id": "d6e54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BOUT THE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTHOR")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05ccf073","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Hunt_9781401684952_epub_c17_r1.vue
// module id = 66
// module chunks = 0